export default "__VITE_ASSET__353db5ca__"